export default "/kiban/_next/static/images/bottom_matteBlack-f4ba82d3e7a7d1b65415eb10ccac9796.png";